var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKnowledgePanelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-ui-name": "Education",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    "data-name": "Education",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.476 1.154a.97.97 0 011.048 0l7 4.463c.296.19.476.523.476.883V13a1 1 0 11-2 0V8.354L12.988 9H13v3.133a1 1 0 01-.22.626c-2.4 2.993-7.16 2.993-9.56 0a1 1 0 01-.22-.626V9h.012L.476 7.383A1.045 1.045 0 010 6.5c0-.36.18-.694.476-.883l7-4.463zm1.048 10.692L11 10.267v1.492c-1.585 1.66-4.415 1.66-6 0v-1.492l2.476 1.58a.97.97 0 001.048 0zM2.908 6.5L8 9.747 13.092 6.5 8 3.253 2.908 6.5z",
    shapeRendering: "geometricPrecision"
  })));
}
export default SvgKnowledgePanelIcon;